export default "__VITE_ASSET__16325f9d__"